import React from "react";
import PageHero from "../components/PageHero";
import ContactSection from "../components/ContactSection";
import { images, sustainability } from "../mock/mock";
import { Leaf } from "lucide-react";

export default function Sustainability() {
  return (
    <main>
      <PageHero image={images.sustainability} eyebrow="Company" title="Sustainability" subtitle={sustainability.body} />
      <section className="bg-white">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-20">
          <div className="max-w-3xl mb-14">
            <p className="text-oe-red font-semibold uppercase tracking-[0.3em] text-xs mb-4">Future Fuels</p>
            <h2 className="oe-heading text-oe-navy text-3xl md:text-4xl mb-6">Leading our industry towards change</h2>
            <p className="text-muted-foreground leading-relaxed">We conduct innovative studies on low-carbon future fuels and collaborate on hybrid renewable power generation. Explore our ongoing research across four key pathways.</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {sustainability.pillars.map((p) => (
              <div key={p.title} className="group border border-gray-100 rounded-xl p-8 hover:shadow-xl hover:-translate-y-1 transition-all">
                <div className="w-14 h-14 rounded-lg bg-secondary flex items-center justify-center mb-6 group-hover:oe-navy transition-colors">
                  <Leaf size={26} className="text-oe-navy group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-oe-navy font-semibold text-xl mb-3">{p.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <ContactSection />
    </main>
  );
}
